<div class="max-w-3xl mx-auto px-4 py-12">
  <!-- Headline -->
  <h1 class="text-3xl  text-center mb-6">
    👋 Welcome to My Blog
  </h1>

  <!-- Intro Card -->
  <mat-card class="p-6 bg-white shadow-sm rounded-xl">
    <mat-card-content class="space-y-4 text-gray-700">
      <p class="text-lg italic">
        “Hi, I’m Aimi. This is where I share thoughts, lessons, and little nuggets of wisdom from the world of 
        <span class="font-semibold">construction contracts</span> and 
        <span class="font-semibold">quantity surveying</span>. Think of it as my journal – sometimes technical, sometimes practical, always human.”
      </p>

      <p class="mt-4">
        I’m just getting started here, so stay tuned. Soon, you’ll find:
      </p>

      <!-- Upcoming Content List -->
      <ul class="list-none space-y-2">
        <li>📚 Simple guides to tricky contract terms</li>
        <li>💡 Tips & tricks from real-life QS practice</li>
        <li>🌍 Updates on industry trends and digital tools</li>
        <li>🧩 Reflections on what I’ve learned along the way</li>
      </ul>

      <p class="mt-6">
        In the meantime, make yourself at home. I can’t wait to start sharing with you.
      </p>

      <p class="font-semibold text-primary-600">– Aimi, your QS Buddy</p>
    </mat-card-content>
  </mat-card>
</div>
